module.exports = __webpack_public_path__ + "img/store.7d8fc001.svg";